import { InputValue } from '@optimus-web/common';
import { DropdownItem } from '../DropdownItem';
import { DropdownItemProps } from '../types';

interface DropdownItemCompatible {
    onClick: (event: React.SyntheticEvent, value: InputValue) => void;
}

// Type guard to check if an element can handle dropdown item props
// Prevents this https://mews.atlassian.net/browse/DX-3731
export const isDropdownItemCompatible = (
    element: React.ReactElement
): element is React.ReactElement<DropdownItemCompatible> =>
    'onClick' in element.props && typeof element.props.onClick === 'function';

// Type guard to check if an element is a dropdown item
export const isDropdownItemElement = (
    element: React.ReactElement
): element is React.ReactElement<DropdownItemProps> => {
    const componentType = element.type as {
        displayName?: string;
        render?: () => React.ReactElement;
    };

    // Check if it's a direct DropdownItem
    const isDirectDropdownItem =
        (element.type === DropdownItem || componentType.displayName?.includes('DropdownItem')) &&
        'label' in element.props;

    // Check if it's a function component that returns a DropdownItem
    const isWrappedDropdownItem =
        typeof element.type === 'function' && (element.type as Function).toString().includes('DropdownItem');

    return !!(isDirectDropdownItem || isWrappedDropdownItem);
};
